import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const productmainApi = createApi({
  reducerPath: "productmainApi",
  baseQuery,
  tagTypes: ["ProductMain","ExportDeclaration"],
  endpoints: (builder) => ({

    getProductInvoiceMainId: builder.query({
      query: ({ id }) => `export/product/main/${id}`,
      transformResponse: (response) => {
        const data = response?.data?.exportProductMain ?? [];

        // Ensure it's always an array
        const normalized = Array.isArray(data) ? data : [data];
        // Add `id` field from exportEntityId
        return normalized.map((item,idx) => ({
          ...item,
          srNo: idx + 1,
          id: item.exportProductId,
          exportProductMainDescriptionId:
            item.isDescription 
              ? item.exportProductMainDescriptionId
              : item.exportProductMainDescription,
          totalAmount: response?.data?.totalAmount ?? 0,
        })); 
      },
      providesTags: ["ProductMain"],
    }),
    // 🔹 Get product by invoiceId + productId
    getProductById: builder.query({
      query: ({ id, subId }) => `export/product/main/${id}/${subId}`,
      transformResponse: (response) => {
        return response?.data ?? [];
      },
      providesTags: ["ProductMain"],
    }),

    // 🔹 Create Product Main
    createProductMain: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/main/${id}`,
        method: "PUT",
        body: { productMain: data },
      }),
      invalidatesTags: ["ProductMain"],
    }),
    //UpdateMain
    updateProductMain: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/export/product/main/${id}/${subId}`,
        method: "PUT",
        body: { productMain: data },
      }),
      invalidatesTags: ["ProductMain"],
    }),

    deleteProductMain: builder.mutation({
      query: ({ id }) => {
        return {
          url: `export/product/main/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["ProductMain"],
    }),
    getProductDeclaration: builder.query({
      query: ({ id,params }) => ({
        url: `export/Declaration/${id}`,
        params,
        method: "GET",
      }),
      transformResponse: (response) =>{
        const data = response?.data
         const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item,idx) => ({
          ...item,
          srNo: idx + 1,
          id: item.exportDeclarationId,
        })); 
        },
      providesTags: ["ExportDeclaration"],
    }),
      createDeclaration: builder.mutation({
      query: ({ id, data }) => ({
        url: `/export/Declaration/${id}`,
        method: "PUT",
        body: { declaration: data },
      }),
      invalidatesTags: ["ExportDeclaration"],
    }),
      updateDeclaration: builder.mutation({
      query: ({ id, subId,data }) => ({
        url: `export/Declaration/${id}/${subId}`,
        method: "PUT",
        body: { declaration: data },
      }),
      invalidatesTags: ["ExportDeclaration"],
    }),
    deleteDeclaration: builder.mutation({
      query: ({ id }) => {
        return {
          url: `export/Declaration/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["ExportDeclaration"],
    })
  }),
});
export const {
  useLazyGetProductInvoiceMainIdQuery,
  useGetProductByIdQuery,
  useCreateProductMainMutation,
  useUpdateProductMainMutation, 
  useDeleteProductMainMutation,
  useLazyGetProductDeclarationQuery,
  useCreateDeclarationMutation,
  useUpdateDeclarationMutation,
  useDeleteDeclarationMutation
} = productmainApi;
